
    import { Component } from 'vue-property-decorator';
    import RepsolTableComponent from '@/components/repsol-table/RepsolTableComponent.vue';
    import { Chip, FormFields, FilterFields, TableHeaderModel } from  '@/models/repsol-template.model';
    import ComponentBase from '@/mixins/componentBase';

    @Component({
        name: 'ReportesPage',
        components: {
            RepsolTableComponent,
        },
    })

    export default class ReportesPage extends ComponentBase {
        items:any[] = [];

        tableHeaders:TableHeaderModel[] = [];

        desde:string;
        hasta:string;

        tableLoading = false;
        totalItems = 0;

        tableOptions = {
        page: 1,
        itemsPerPage: 10,
        sortBy: [] as string[],
        sortDesc: [] as boolean[],
      };

        constructor() {
          super();
        }

        mounted() {
          this.tableHeaders =
            [
                                                                { text: 'reportes.process_month', value: "mes", sortable: true, as:'text' },
                                                                { text: 'reportes.strategy', value: "estrategia", sortable: true, as:'number' },
                                                                { text: 'reportes.lots', value: "lotes", sortable: true, as: 'number'},
                                                                { text: 'reportes.commodity', value: "commodity", sortable: true, as: 'text' },
                                                                { text: 'reportes.market', value: "mercado", sortable: true, as: 'text' },
                { text: '', value: "actions", sortable: false, as:'', actions:[] },
            ];

            var date = new Date(), y = date.getFullYear(), m = date.getMonth()+1;
            var lastDay = new Date(y, m, 0);

            this.desde = `${y}-${("0" + m).slice(-2)}-01`;
            this.hasta = `${y}-${("0" + m).slice(-2)}-${("0" + lastDay.getDate()).slice(-2)}`;
            this.getReportesList();
          
        }

        onTableOptionsChanged(options: any) {
        this.tableOptions = { ...options };
        this.getReportesList();
        }

        async getReportesList(){

            this.openSpinner("reportes.cargarListado");

            this.items = [];
            const filtro: any = {
                desde: this.desde,
                hasta: this.hasta
            };
            
           const page = this.tableOptions?.page ?? 1;
            const itemsPerPage = this.tableOptions?.itemsPerPage ?? 10;
            const sortBy = this.tableOptions?.sortBy ?? [];
            const sortDesc = this.tableOptions?.sortDesc ?? [];
            filtro.PageNumber = page || 1;
            filtro.PageSize = itemsPerPage || 10;

         if (sortBy && sortBy.length) {
            filtro.sortBy = sortBy[0];
            filtro.sortDesc = !!(sortDesc && sortDesc[0]);
        }

            const route = '/api/reporte/list';
            this.post({ apiUrl: route, entity: filtro })
            .then(data => {
                console.log(data.items);
                if (Array.isArray(data.items)) {
                    this.items = data.items;
                    this.totalItems = data.totalCount ?? 0;
            } else {
                    this.items = data?.items ?? [];
                    this.totalItems = data?.totalCount ?? 0;
                }
            })
            .catch(error =>{
                this.mostrarKO("reportes.koListado");
            })
            .finally(() => {
                this.closeSpinner();
            });
        }

        tableEventAction(action:string, item:any): void {
            return;
        }

        rulesForm = {
            desde: [this.required()],
            hasta: [this.required()],
        };
    }
